import { NgModule } from '@angular/core';

import { AbsoluteNumberPipe } from '@1clickfactory/common/pipes/absolute-number.pipe';
import { QuantityHintPipe } from '@1clickfactory/common/pipes/quantity-hint.pipe';
import { DeprecatedParseHtmlPipe } from './deprecated-parse-html.pipe';
import { FromNowPipe } from './from-now.pipe';
import { IsoDateWithTimePipe } from './iso-date-with-time.pipe';
import { MoneyPipe } from './money.pipe';
import { NotEmptyPipe } from './not-empty.pipe';
import { ParseEscapedHtmlPipe } from './parse-escaped-html.pipe';
import { PrefixPipe } from './prefix.pipe';
import { SuffixPipe } from './suffix.pipe';
import { TakePipe } from './take.pipe';
import { TruncatePipe } from './truncate.pipe';

const exportedDeclarations = [
  FromNowPipe,
  IsoDateWithTimePipe,
  MoneyPipe,
  NotEmptyPipe,
  PrefixPipe,
  TakePipe,
  TruncatePipe,
  SuffixPipe,
  QuantityHintPipe,
  AbsoluteNumberPipe,
  DeprecatedParseHtmlPipe,
  ParseEscapedHtmlPipe,
];

@NgModule({
  declarations: exportedDeclarations,
  exports: exportedDeclarations,
})
export class PipesModule {}
